import { render, staticRenderFns } from "./increase.vue?vue&type=template&id=68627692&"
import script from "./increase.vue?vue&type=script&lang=js&"
export * from "./increase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/kccp/PROD/kccp-portal-web-internet-dynamic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('68627692', component.options)
    } else {
      api.reload('68627692', component.options)
    }
    module.hot.accept("./increase.vue?vue&type=template&id=68627692&", function () {
      api.rerender('68627692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/request/extend/increase.vue"
export default component.exports